module.exports = __webpack_public_path__ + "static/media/logo-covid-response.b444c121.png";